<template>
  <hypto-popup :title="webhookOptions.title">
    <template v-slot:body>
      <md-field :class="{'input-error': $v.url.$error}">
        <label>URL</label>
        <md-input v-model="url" @blur="$v.url.$touch" />
      </md-field>
      <h6 class="error-message" v-if="$v.url.$error && !$v.url.required">Please provide a webhook url</h6>
      <h6 class="error-message" v-else-if="$v.url.$error && !$v.url.url">Please provide a valid webhook url</h6>

      <md-field>
        <label>Authorization <i>(optional)</i></label>
        <md-input v-model="auth" />
      </md-field>

      <div class="preview-panel">
        <div class="url">
          <span>
            <b>URL:</b>&nbsp;
            <p>{{url}}</p>
          </span>
          <button @click="testWebhook" :disabled="isDisableButton">Test Webhook</button>
        </div>

        <div class="headers">
          <b>Headers</b>
          <p>"Content-Type": "application/x-www-form-urlencoded"</p>
          <p v-if="auth">"Authorization": "{{auth}}"</p>
        </div>

        <p>Refer <a target="_blank" href="https://www.hypto.in/docs">API Docs</a> for payload</p>
      </div>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="doAction" :disabled="isDisableButton">{{webhookOptions.type}}</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import { required, url } from 'vuelidate/lib/validators'
import ApiServices from '@/services/api/webhooks'
import { mapMutations } from 'vuex'
import formMixins from '@/mixins/formMixins'

export default {
  name: 'ConfigureWebhook',
  components: { HyptoPopup },
  props: {
    webhookOptions: Object
  },
  mixins: [formMixins],
  data () {
    return {
      url: null,
      auth: null
    }
  },
  validations: {
    url: {
      required,
      url
    }
  },
  created () {
    if (this.webhookOptions.type === 'Update') {
      this.url = this.webhookOptions.url
      this.auth = this.webhookOptions.authorization
    }
  },
  methods: {
    ...mapMutations(['SET_POPUP_NAME']),
    doAction () {
      this.$v.$touch()
      if (!this.$v.$error) {
        let params = {
          url: this.url,
          authorization: this.auth
        }

        if (this.webhookOptions.type === 'Configure') {
          params['category'] = this.webhookOptions.category
          this.configureWebhook(params)
        } else {
          this.updateWebhook(params)
        }
      }
    },
    configureWebhook (params) {
      ApiServices.configureWebhook(params).then((response) => {
        this.handleResponse(response)
      })
    },
    updateWebhook (params) {
      ApiServices.updateWebhook(this.webhookOptions.category, params).then((response) => {
        this.handleResponse(response)
      })
    },
    handleResponse (response) {
      if (response.success) {
        this.successToastMsg(response.message)
        this.SET_POPUP_NAME(null)
        this.$emit('refreshWebhook')
      } else {
        this.errorToastMsg(response.message)
      }
      this.enableButton()
    },
    testWebhook () {
      this.$v.$touch()
      if (!this.$v.$error) {
        let params = {
          category: this.webhookOptions.category,
          url: this.url,
          authorization: this.auth
        }

        ApiServices.testWebhook(params).then((response) => {
          response.success ? this.successToastMsg(response.message) : this.errorToastMsg(response.message)
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .preview-panel {
    border-radius: 10px;
    background: $grey-bg;
    padding: 15px;
    margin-top: 15px;

    p {
      @include normal-text($secondary, 14px);
    }
    b {
      @include highlight-text($secondary, 14px);
    }

    .url {
      @include custom-flex(space-between);

      span {
        display: flex;
      }

      button {
        @include normal-text($primary, 14px, 500);

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .headers {
      margin: 15px 0;

      p {
        margin-left: 10px;
      }
    }

    a {
      color: $primary !important;

      &:hover {
        text-decoration: underline !important;
      }
    }
  }

  .mobile {
    .preview-panel {
      .url {
        @include custom-flex('', flex-start, column-reverse);

        button {
          margin: 10px 0;
          padding: 0;
        }
      }
    }
  }
</style>
